export const ATS_SHARED_CANDIDATE_FORM = 'ATS_SHARED_CANDIDATE_FORM';
